export default __webpack_public_path__ + "static/media/Download.b3a2078e.svg";